/*
 * @Author: libo 
 * @Date: 2020-11-13 16:48:07 
 * @Last Modified by: mayanxia
 * @Last Modified time: 2021-11-12 16:33:10
 */

<template>
  <j-modal
    :title="title"
    :width="width"
    :visible="visible"
    switchFullscreen
    @ok="handleOk"
    :okButtonProps="{ class:{'jee-hidden': disableSubmit} }"
    @cancel="handleCancel"
    :cancelText="$t('关闭')">
    <meter-caliber-form ref="realForm" @ok="submitCallback" :disabled="disableSubmit"></meter-caliber-form>
  </j-modal>
</template>

<script>

  import MeterCaliberForm from './MeterCaliberForm'
  export default {
    name: 'MeterCaliberModal',
    components: {
      MeterCaliberForm
    },
    data () {
      return {
        title:'',
        width:800,
        visible: false,
        disableSubmit: false
      }
    },
    methods: {
      add () {
        this.visible=true
        this.$nextTick(()=>{
          this.$refs.realForm.add();
        })
      },
      edit (record) {
        this.visible=true
        this.$nextTick(()=>{
          this.$refs.realForm.edit(record);
        })
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        this.$refs.realForm.submitForm();
      },
      submitCallback(){
        this.$emit('ok');
        this.visible = false;
      },
      handleCancel () {
        this.close()
      }
    }
  }
</script>